import type { Sound } from "@/lib/supabase-types";

interface HomeHeroMedia {
  src: string;
  objectPosition: string;
}

const HOME_HERO_MEDIA = {
  "iron-man-jarvis-defense-protocol-marvel": {
    src: "/images/home/hero/iron-man-jarvis.jpg",
    objectPosition: "72% center",
  },
  "fahhh-steven-he-viral-exhale": {
    src: "/images/home/hero/fahhh.jpg",
    objectPosition: "76% center",
  },
  "super-mario-death-sound-classic-game-over": {
    src: "/images/home/hero/mario-death.jpg",
    objectPosition: "72% center",
  },
  "windows-xp-shutdown-classic-pc-farewell": {
    src: "/images/home/hero/windows-xp-shutdown.jpg",
    objectPosition: "74% center",
  },
  "star-trek-security-enabled-computer-chime": {
    src: "/images/home/hero/star-trek-security.jpg",
    objectPosition: "72% center",
  },
  // Halloween pin (lib/home-hero-pin.ts). Remove with the pin after the window.
  "michael-myers-sound-dead-by-daylight-horror": {
    src: "/images/home/hero/michael-myers.jpg",
    objectPosition: "74% center",
  },
} as const satisfies Record<string, HomeHeroMedia>;

export function resolveHomeHeroMedia(
  sound: Pick<Sound, "slug">,
): HomeHeroMedia | undefined {
  if (!sound.slug) return undefined;
  return HOME_HERO_MEDIA[sound.slug as keyof typeof HOME_HERO_MEDIA];
}
